import { render, staticRenderFns } from "./HoldingReport.vue?vue&type=template&id=758eea54&"
import script from "./HoldingReport.vue?vue&type=script&lang=js&"
export * from "./HoldingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports